/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';

/**
 *
 * @export
 * @interface VoiceAgentGenerationInputsCreate
 */
export interface VoiceAgentGenerationInputsCreate {
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof VoiceAgentGenerationInputsCreate
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentGenerationInputsCreate
   */
  nSamples: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentGenerationInputsCreate
   */
  seedDataset: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentGenerationInputsCreate
   */
  inferencerId: number;
}

/**
 * Check if a given object implements the VoiceAgentGenerationInputsCreate interface.
 */
export function instanceOfVoiceAgentGenerationInputsCreate(value: object): value is VoiceAgentGenerationInputsCreate {
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencerId' in value) || value['inferencerId'] === undefined) return false;
  return true;
}

export function VoiceAgentGenerationInputsCreateFromJSON(json: any): VoiceAgentGenerationInputsCreate {
  return VoiceAgentGenerationInputsCreateFromJSONTyped(json, false);
}

export function VoiceAgentGenerationInputsCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentGenerationInputsCreate {
  if (json == null) {
    return json;
  }
  return {
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: json['seed_dataset'],
    inferencerId: json['inferencer_id'],
  };
}

export function VoiceAgentGenerationInputsCreateToJSON(value?: VoiceAgentGenerationInputsCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
    seed_dataset: value['seedDataset'],
    inferencer_id: value['inferencerId'],
  };
}
